import { render, staticRenderFns } from "./UserRoutes.vue?vue&type=template&id=4e01fb72&"
import script from "./UserRoutes.vue?vue&type=script&lang=js&"
export * from "./UserRoutes.vue?vue&type=script&lang=js&"
import style0 from "./UserRoutes.vue?vue&type=style&index=0&id=4e01fb72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports